// extracted by mini-css-extract-plugin
module.exports = {"layout":"HomeLayout_layout__H9gb1","container":"HomeLayout_container__vfZlo"};